import { render, staticRenderFns } from "./SunsetSvg.vue?vue&type=template&id=72823d0c&"
import script from "./SunsetSvg.vue?vue&type=script&lang=js&"
export * from "./SunsetSvg.vue?vue&type=script&lang=js&"
import style0 from "./SunsetSvg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports